/**
 * Cart Count Animation Handler
 * Adds a pop animation to the cart count bubble when items are added to cart
 */

(function() {
  'use strict';

  // Declared with var: the theme's CDN minifier hoists function declarations
  // above let/const at module scope, which would make this a TDZ reference.
  var lastAnimatedCount = null;

  // The count the bubble is currently showing, or '0' when there is no bubble.
  function currentCount() {
    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return '0';
    const visible = bubble.querySelector('[aria-hidden="true"]');
    const screenReader = bubble.querySelector('.visually-hidden');
    const source = (visible && visible.textContent) || (screenReader && screenReader.textContent) || '';
    return `${source}`.replace(/[^0-9]/g, '') || '0';
  }

  function pop(bubbles) {
    Array.prototype.forEach.call(bubbles, bubble => {
      bubble.classList.remove('pop');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          bubble.classList.add('pop');

          setTimeout(() => {
            bubble.classList.remove('pop');
          }, 600);
        });
      });
    });
  }

  /**
   * Trigger cart count bubble animation.
   * Callers that have already updated the bubble synchronously pass their own
   * elements and get the pop on the next frame; the pub/sub path passes nothing
   * and keeps the delay, which is there to let the section re-render land first.
   */
  function animateCartCount(bubbles) {
    if (bubbles && bubbles.length) {
      lastAnimatedCount = currentCount();
      pop(bubbles);
      return;
    }

    setTimeout(() => {
      lastAnimatedCount = currentCount();
      pop(document.querySelectorAll('.cart-count-bubble'));
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (event.source === 'product-form' || event.source === 'quick-add' || event.source === 'quick-add-bulk') {
          // An optimistic path may have popped the bubble already at click time.
          // Compare counts rather than elapsed time: the response can land well
          // after any fixed window, and a genuinely different count (a second
          // quick-add, say) still deserves its own pop. Kept inside the source
          // check so a source added later doesn't silently inherit it.
          if (currentCount() === lastAnimatedCount) return;
          animateCartCount();
        }
      });
    } else {
      setTimeout(init, 1000);
    }
  }

  window.animateCartCount = animateCartCount;
})();
